export default __webpack_public_path__ + "static/media/Group1328.6c51485e.svg";